import { IAnyActionComposerMap } from './composeActions';
import { IModule } from './types';

function conflictingModuleNames<P, S, T extends IAnyActionComposerMap<S>>(modules: IModule<P, S, T>[]) {
  const moduleNames = modules.map((mod) => mod.name);

  const nameCounts = moduleNames.reduce(
    (names, moduleName) =>
      Object.assign(names, {
        [moduleName]: ((names[moduleName] as number) || 0) + 1
      }),
    {}
  );

  const duplicatedNames = moduleNames.filter((moduleName) => nameCounts[moduleName] > 1);

  if (duplicatedNames.length > 0) {
    throw new Error(`Duplicate module names: [ ${duplicatedNames.join(', ')} ]`);
  }

  return false;
}

function missingModuleNames<P, S, T extends IAnyActionComposerMap<S>>(modules: IModule<P, S, T>[]) {
  const moduleMissingName = modules.find((mod) => !mod.name);

  if (moduleMissingName) {
    throw new Error('Module missing name!');
  }

  return false;
}

export function assertModuleSanity<P, S, T extends IAnyActionComposerMap<S>>(modules: IModule<P, S, T>[]) {
  return !(missingModuleNames(modules) || conflictingModuleNames(modules));
}
